import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BookingServiceConfig = {
  name: "Booking",
  annotations: []
} as ServiceConfig;